import React, { useState, useEffect } from 'react'
import { Form, Button, Accordion } from 'semantic-ui-react'
import Panel from '../shared/Panel'
import PropTypes from "prop-types";
import _ from 'lodash'
import { useTextResources } from '../../language';
import { onWarning, onError } from '../../components/shared/messages'
import { useLoader } from '../shared/utils';
import moment from 'moment';

const SearchPanel = ({ options, onSetState, onSearchComplete}) => {
  const text = useTextResources()
  const loader = useLoader()

  const convert = state => {
    const result = { ...state }
    _.each(state, (value, key) => {
      if (_.isDate(value)) {
        result[key] = moment(value).toISOString(true)
      }
    })
    return result
  }

  const [state, setState] = useState(convert(options.initial) || {})
  const [values, setValues] = useState(options.initial || {})

  useEffect(() => {
    if (options.setDoSearchRef) {
      options.setDoSearchRef(doSearch);
    }
  }, [options.setDoSearchRef])
  
  useEffect(() => {
    if (options.searchOnLoad) {
      doSearch()
    }
  }, [options.searchOnLoad])

  useEffect(() => {
    if (onSetState) {
      onSetState(state)
    }
  }, [state])


  const onChangeField = (key, value) => {
    const changes = {}
    if (_.isDate(value)) {
      changes[key] = moment(value).toISOString(true)
    }
    else if (_.isArray(value) && options.method !== "POST") {
      _.forEach(value, (value, index) => {
        if(_.isDate(value)){
            changes[`${key}[${index}]`] = moment(value).toISOString(true)
        } else {
            changes[`${key}[${index}]`] = value
        }
      });
    }
    else {
      changes[key] = value || undefined
    }
    const field = options.fields.find(f => f.key === key) || options.advancedFields.find(f => f.key === key)

    if (field && field.props.onChange) {
      field.props.onChange(value);
    }
    setState(prev => {
      return _.merge(_.omitBy(prev, (v, k) => k.startsWith(key)), changes)
    })
    setValues(prev => {
      prev[key] = value
      return prev
    })
  }

  const doSearch = async () => {
    if (options.api) {
      try {
        loader(true)
        if (!options.validate || options.validate({ ...state, ...options.spec })) {
          const data = await options.api({ ...state, ...options.spec })
          onSearchComplete(data, state)
        }
      } catch (error) {
        error.status === 400 ? onWarning(error) : onError(error)
      }
      finally {
        loader(false)
      }
    } else if (options.customSearch ) {
      options.customSearch(state)
    }
  }

  return (
    <Panel header={options.title} subheader={options.description}>
      <Form>
        {
          _.chunk(options.fields, options.groupSize || 8).map((chunk, idx) => {
            return <Form.Group key={`Field${idx}`} widths={options.groupSize || 8}>
              {
                chunk.map(field => {
                  return React.cloneElement(field, { value: values[field.key], onChange: value => onChangeField(field.key, value) })
                })
              }
            </Form.Group>
          })
        }
        {
          options.advancedFields &&
          <Accordion panels={[
            {
              title: text("Advanced"),
              key: 'Advanced',
              content: {
                content: _.chunk(options.advancedFields, options.groupSize || 8).map((chunk, idx) => {
                  return <Form.Group key={`AdvField${idx}`} widths={options.groupSize || 8}>
                    {
                      chunk.map(field => {
                        return React.cloneElement(field, { value: values[field.key], onChange: value => onChangeField(field.key, value) })
                      })
                    }
                  </Form.Group>
                })
              }
            }
          ]}>
          </Accordion>
        }
        <Form.Field style={{ textAlign: "right" }}>
          {options.buttons}
          <Button primary type="submit" onClick={doSearch}>{options.buttonText || text("Search")}</Button>
        </Form.Field>
      </Form>
    </Panel>
  )
}

SearchPanel.propTypes = {
  options: PropTypes.object,
  onSearchComplete: PropTypes.func,
  onSetState: PropTypes.func
}
export default SearchPanel